<template>
    <ion-col class="ion-col" :style="backgroundStyle" :size="isPortraitOrientation ? '12' : '6'">
        <div class="content-block" :style="contentPadding" v-html="promoBlock?.content" ref="contentRef"></div>
    </ion-col>
</template>
<script lang="ts">
import { computed, defineComponent, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { PromoBlockModel } from '@/models/PromoBlockModel';
import { IonCol } from '@ionic/vue';
import useVueLinks from '@/composables/useVueLinks';
export default defineComponent({
    setup() {
        const store = useStore();
        const isMobile = computed(() => store.getters.isMobile);
        const isPortraitOrientation = computed(() => store.getters.isPortraitOrientation);
        const contentRef = ref();

        onMounted(() => useVueLinks(contentRef.value));
        return { isMobile, isPortraitOrientation, contentRef };
    },
    props: {
        promoBlock: PromoBlockModel,
        whichBlock: { type: String, default: 'firstBlock' },
    },
    components: { IonCol },
    computed: {
        backgroundStyle() {
            const isCenterText = this.promoBlock?.textAlignDirection(this.isPortraitOrientation) == 'center';
            const isEmpty = this.promoBlock?.content == '';
            const justification = this.whichBlock == 'firstBlock' ? 'left' : 'right';

            return `
        background: ${isEmpty ? 'unset' : this.promoBlock?.contentBackgroundStyle(this.isPortraitOrientation, this.whichBlock)};
        background-clip: content-box, padding-box;
        justify-content: ${this.isPortraitOrientation || isCenterText ? 'center' : justification};
        padding: ${this.promoBlock?.margin(this.isPortraitOrientation)};
        text-align: ${this.promoBlock?.textAlignDirection(this.isPortraitOrientation)}
        `;
        },
        contentPadding() {
            const isCenterText = this.promoBlock?.textAlignDirection(this.isPortraitOrientation) == 'center';
            const justification = this.whichBlock == 'firstBlock' ? 'left' : 'right';

            if (this.isPortraitOrientation || isCenterText) {
                return `padding: 15x;`;
            } else {
                return `padding-${justification}: 40px`;
            }
        },
    },
});
</script>

<style scoped>
.banner-grid {
    color: white;
    min-height: 400px;
}
ion-row {
    height: 100%;
}
ion-grid {
    padding: unset;
}
.content-block {
    padding: 0;
    max-width: 700px;
}
.ion-col {
    display: flex;
    align-items: center;
    padding: unset;
}
.stacked-content-blocks > .ion-col {
    /*height: 50%;*/
}
</style>
